import { useState } from 'react';
import './signIn.scss';
import { useNavigate } from 'react-router-dom';
import { postLogin } from '../../common/api/apiCalls';
import { useUser } from '../../common/contexts/UserContext';
import { roles } from '../../common/types/roles';
import { svgs } from '../../common/assats';
import { useTranslation } from 'react-i18next';
import TextInputWithIcon from '../../components/TextInputWithIcon';
import PasswordInputWithIcon from '../../components/PasswordInputWithIcon';
import Button from '../../components/Button';
import { loginSchema } from '../../common/consts/yupSchems';
import { ValidationError } from 'yup';
import { useAlert } from '../../common/contexts/AlertContext';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

function SignIn() {
    const { t } = useTranslation()
    const { user, fetchUser } = useUser();
    const navigate = useNavigate()
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState<{ email?: string[], password?: string[] }>({})
    const alert = useAlert();
    const { executeRecaptcha } = useGoogleReCaptcha();


    const getText = (text: string) => t(`sign_in.${text}`)

    async function validate() {
        try {
            await loginSchema.validate({ password, email }, { abortEarly: false });
            setErrors({});
            return true; // Validation succeeded
        } catch (err: any) {
            if (err instanceof ValidationError) {
                const validationErrors: { email?: string[]; password?: string[] } = { email: [], password: [] };
                err.inner.forEach((error: any) => {
                    const path = error.path as keyof typeof validationErrors;
                    if (path && validationErrors[path]) {
                        validationErrors[path]?.push(error.message); // Collect multiple errors for each field
                    }
                });
                setErrors(validationErrors);
            }
            return false; // Validation failed
        }
    };

    async function submit() {
        if (!email || !password) return
        if (await validate()) {
            if (!executeRecaptcha) {
                console.error("reCAPTCHA function not available");
                return;
            }
            let captchaValue: string | null = null;
            try {
                captchaValue = await executeRecaptcha('login');
            } catch (err) {
                console.error('Error executing reCAPTCHA:', err);
            }
            if (!captchaValue) {
                alert("Error with reCAPTCHA, please try again.","error");
                return;
            }

            const res = await postLogin({ username: email as string, password: password as string, recaptchaToken: captchaValue });
            if (res.success) {
            await fetchUser()
                alert(getText("loginSuccess"), "msg");
                navigate("/Register/SetNewPassword", { replace: true, })
            } else
                alert(getText("loginFailed"), "error");
        }
    };


    return (
        <div className='sign-in-main-container flex-center'>
            <div className='login-content'>
                <h3 className='headline'> {getText("welcome_to")}</h3>
                <svgs.logos.Logo className='logo' />
                <div className="input-wrapper">

                    <p className='text'>{getText("enter_your_details_below_to_get_started")}</p>
                    <TextInputWithIcon
                        errors={errors}
                        label={getText("Email")}
                        Icon={svgs.logos.Mail}
                        placeholder={getText('Enter_your_email')}
                        setValue={setEmail}
                        value={email}
                        inputName="email"
                        filedCorrect={Boolean(errors?.email && !email.length) ? false : undefined}
                    />
                    <PasswordInputWithIcon
                        label={getText("Temporary_Password")}
                        errors={errors}
                        placeholder={getText('Enter_your_password')}
                        setValue={setPassword}
                        value={password}
                    />

                </div>
                <Button onClick={submit} text={getText("sign_in")} />
            </div>
        </div>
    );
}

export default SignIn;
